import React from 'react';
import TransactionTypeToggles from '../../../../../../Subscription/Content/Transactions/TransactionCandles/TransactionTypeToggles';

interface Props {
  useTakeProfitTransactions: boolean;
  transactionTypeToggleValues: {
    core: boolean;
    takeProfit: boolean;
    stopLoss: boolean;
  };
  setTransactionTypeToggleValues: React.Dispatch<
    React.SetStateAction<{
      core: boolean;
      takeProfit: boolean;
      stopLoss: boolean;
    }>
  >;
}

const TransactionFilter = (props: Props) => {
  const {
    useTakeProfitTransactions,
    transactionTypeToggleValues,
    setTransactionTypeToggleValues,
  } = props;

  return (
    <div style={{ marginTop: 10 }}>
      <TransactionTypeToggles
        useTakeProfitTransactions={useTakeProfitTransactions}
        transactionTypeToggleValues={transactionTypeToggleValues}
        setTransactionTypeToggleValues={setTransactionTypeToggleValues}
      />
    </div>
  );
};

export default TransactionFilter;

// More filtering to add
/**
 * all buy sell
 * profitable or not
 * Start and end timestamp
 */
